import { store } from "@store" //eslint-disable-line
import { initAxios } from '@technologyadvice/relay-frontend/src/util/axios'

const axiosV2 = initAxios(store, '/clicks/v2/api/')

export { axiosV2 }

export default initAxios(store, '/clicks/bff')
